import { FlexContainer } from '@/ui/styled-ui';
import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import styled from 'styled-components';

const StyledIconWrapper = styled.span`
  display: flex;
  width: 32px;
  height: 32px;
  background: var(--white-main);
  cursor: default;
  justify-content: center;
  align-items: center;
  border-radius: var(--xxsmall-border-radius);
  transition: all 0.4s;

  &:hover {
    background-color: var(--white-main);
  }

  i {
    font-size: 18px;
  }
`;

const StyledSubtitle = styled.div`
  color: var(--purple-dark);
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 500;
  width: 100%;
  &.red {
    color: var(--red-main);
    font-weight: 700;
  }
`;

export const RedSpan = styled.span`
  color: var(--red-main);
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 700;
  margin: 0;
`;

const StyledContainer = styled(FlexContainer)`
  &.card-info-link {
    cursor: pointer;
    &:hover span.uppercase {
      color: var(--red-main);
    }
    &.v2:hover span.uppercase {
      color: var(--purple-text) !important;
    }
  }
`;

type CardInfoProps = {
  id: string;
  title: string;
  tooltip: string;
  style?: React.CSSProperties;
  subtitle?: string;
  redTitle?: string;
  className?: string;
  onClick?: () => void;
};

export const CardInfo: React.FC<CardInfoProps> = ({
  id,
  title,
  tooltip,
  style,
  subtitle,
  redTitle,
  className,
  onClick,
}) => (
  <StyledContainer
    justify="space-between"
    align="flex-start"
    gap={18}
    style={style}
    className={className}
    onClick={onClick}
  >
    <FlexContainer direction="column">
      <FlexContainer justify="flex-start" align="center" gap={8} wrap="wrap">
        <span className="uppercase">{title}</span>
        {redTitle && <RedSpan>{redTitle}</RedSpan>}
      </FlexContainer>

      {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
    </FlexContainer>

    <>
      <StyledIconWrapper id={id}>
        <i className="pi pi-info-circle" />
      </StyledIconWrapper>
      <Tooltip target={`#${id}`} position="bottom" content={tooltip} />
    </>
  </StyledContainer>
);
